import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from '@tanstack/react-query';
import { examsApi } from 'App';
import {
  ExamFormValues,
  getProctoringType,
  getSecureBrowserSettings,
  parseDate,
  useToast,
} from '@shared';

type TypeProps = {
  partner: string;
  course: string;
  exam: string;
  rootPath: string;
};

export function useUpdateExam({ partner, course, exam, rootPath }: TypeProps) {
  const navigate = useNavigate();
  const toast = useToast();
  const { data, isLoading } = useQuery(['exam-by-id', exam], () => examsApi.get(exam), {
    cacheTime: 0,
    select: (data) => {
      const { exam: examAPI } = data;
      return {
        name: examAPI.label,
        url: examAPI.url,
        password: examAPI.password,
        start: examAPI.startTime && parseDate(examAPI.startTime),
        end: examAPI.endTime && parseDate(examAPI.endTime),
        secureBrowserSettings: getSecureBrowserSettings(data),
        proctoringOption: getProctoringType(data),
      } as ExamFormValues;
    },
  });
  const { mutate: updateExam, isLoading: isUpdating } = useMutation({
    mutationFn: (data: ExamFormValues) => examsApi.updateExam(partner, course, exam, data),
    onSuccess: () => {
      toast.success('Exam has been updated');
      navigate(rootPath);
    },
  });
  return {
    data,
    isLoading,
    updateExam,
    isUpdating,
  };
}
